import { render, staticRenderFns } from "./EditCooperate.vue?vue&type=template&id=6227df60&scoped=true&"
import script from "./EditCooperate.vue?vue&type=script&lang=js&"
export * from "./EditCooperate.vue?vue&type=script&lang=js&"
import style0 from "./EditCooperate.vue?vue&type=style&index=0&id=6227df60&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6227df60",
  null
  
)

export default component.exports